import { useNavigate } from 'react-router-dom';
import { useAuth } from '../state/AuthContext';
import { api } from '../api/client';

export function TopBar({ applicationName }: { applicationName?: string }) {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await api.post('/api/auth/logout');
    await refresh();
    navigate('/', { replace: true });
  }

  return (
    <header className="top-bar">
      <a className="brand" href="https://apply.krovance.com/">
        Krovance Careers{applicationName && <><span className="brand-separator"> | </span><span className="brand-application">{applicationName}</span></>}
      </a>
      {user && (
        <div className="user-chip">
          {user.pictureUrl && <img className="avatar" src={user.pictureUrl} alt="" />}
          <span>{user.name}</span>
          <button type="button" className="link-button" onClick={handleLogout}>Sign out</button>
        </div>
      )}
    </header>
  );
}
